document.addEventListener('DOMContentLoaded', function () {

    // ── Header scroll ────────────────────────────────────────
    const header = document.querySelector('header');
    let scrollTop = window.scrollY;
    let lastScrollTop = scrollTop;

    if (scrollTop > 0) header.classList.add('header--scrolled');

    var ticking = false;

    function onScroll() {
        scrollTop = window.scrollY;

        if (header.classList.contains('autoHide')) {
            if (scrollTop < lastScrollTop - 20) {
                header.classList.remove('header--hide');
            } else if (scrollTop > header.offsetHeight) {
                header.classList.add('header--hide');
            }
        }

        scrollTop > 0
            ? header.classList.add('header--scrolled')
            : header.classList.remove('header--scrolled');

        lastScrollTop = scrollTop;
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    }, { passive: true });

    // ── Mobile sub-menu ──────────────────────────────────────
    document.querySelectorAll('.menu-header .menu-item-has-children > a').forEach(function (link) {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var sub = this.nextElementSibling;
            if (!sub) return;
            if (sub.style.maxHeight) {
                sub.style.maxHeight = null;
                sub.style.opacity   = '0';
            } else {
                sub.style.maxHeight = sub.scrollHeight + 'px';
                sub.style.opacity   = '1';
            }
        });
    });

    // ── Burger ───────────────────────────────────────────────
    var burger = document.querySelector('.header__burger, .home-header__burger');
    if (burger) {
        burger.addEventListener('click', function () {
            document.body.classList.toggle('menu-open');
        });
    }

    document.querySelectorAll('.menu-item a, .home-header__mobile-link').forEach(function (link) {
        link.addEventListener('click', function () {
            if (burger) burger.classList.remove('active');
            document.body.classList.remove('menu-open');
        });
    });

    // ── Home: плавный скролл по якорям (#form и т.д.) с учётом залипающего хедера ──
    if (document.querySelector('.page-home')) {
        var homeHeader = document.querySelector('.home-header');
        document.querySelectorAll('.home-header a[href*="#"], .page-home a[href*="#"]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var href = link.getAttribute('href') || '';
                var hash = href.charAt(0) === '#' ? href : (href.indexOf('#') !== -1 ? href.slice(href.indexOf('#')) : '');
                if (!hash || hash === '#') return;
                var target = document.querySelector(hash);
                if (!target) return;
                e.preventDefault();
                var offset = (homeHeader ? homeHeader.offsetHeight : 0) + 16;
                var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({ top: top, behavior: 'smooth' });
                document.body.classList.remove('menu-open'); // закрыть мобильное меню
            });
        });
    }

    // ── Stats counter ────────────────────────────────────────
    var statEls = document.querySelectorAll('.stats__item-value[data-target]');
    if (statEls.length && 'IntersectionObserver' in window) {
        var statsObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                statsObserver.unobserve(entry.target);

                var el        = entry.target;
                var target    = parseInt(el.dataset.target, 10);
                var prefix    = el.dataset.prefix  || '';
                var suffix    = el.dataset.suffix  || '';
                var thousands = el.dataset.thousands === '1';
                var duration  = 1500;
                var startTime = null;

                function easeOutQuad(t) { return t * (2 - t); }

                function formatNum(n) {
                    return thousands
                        ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        : n.toString();
                }

                function step(ts) {
                    if (!startTime) startTime = ts;
                    var progress = Math.min((ts - startTime) / duration, 1);
                    el.textContent = prefix + formatNum(Math.round(easeOutQuad(progress) * target)) + suffix;
                    if (progress < 1) requestAnimationFrame(step);
                }

                requestAnimationFrame(step);
            });
        }, { threshold: 0.3 });

        statEls.forEach(function (el) { statsObserver.observe(el); });
    }

    // ── Home trust stats counter (0 → value over 1s on scroll) ─
    var trustVals = document.querySelectorAll('.home-trust__stat-value[data-count]');
    if (trustVals.length && 'IntersectionObserver' in window) {
        var trustObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                trustObserver.unobserve(entry.target);

                var el  = entry.target;
                var raw = el.dataset.count || el.textContent;
                var m   = raw.match(/^([\d.]+)(.*)$/); // числовая часть + хвост (k, %, …)
                if (!m) return;

                var target   = parseFloat(m[1]);
                var tail     = m[2];
                var decimals = (m[1].split('.')[1] || '').length;
                var duration = 1000;
                var startTime = null;

                function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

                function step(ts) {
                    if (!startTime) startTime = ts;
                    var progress = Math.min((ts - startTime) / duration, 1);
                    el.textContent = (target * easeOutCubic(progress)).toFixed(decimals) + tail;
                    if (progress < 1) requestAnimationFrame(step);
                    else el.textContent = m[1] + tail; // точное финальное значение
                }

                requestAnimationFrame(step);
            });
        }, { threshold: 0.5 });

        trustVals.forEach(function (el) { trustObserver.observe(el); });
    }

    // ── Accordion — open first item on load ──────────────────
    document.querySelectorAll('.accordion__list').forEach(function (list) {
        var firstOpen = list.querySelector('.accordion__item--open');
        if (firstOpen) {
            var body = firstOpen.querySelector('.accordion__body');
            body.style.maxHeight = body.scrollHeight + 'px';
            body.style.opacity   = '1';
        }
    });

    // ── Accordion ────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.accordion__trigger');
        if (!trigger) return;

        var item   = trigger.closest('.accordion__item');
        var isOpen = item.classList.contains('accordion__item--open');

        // Read all scrollHeights before any writes (avoid layout thrashing)
        var toClose = Array.from(
            item.closest('.accordion__list').querySelectorAll('.accordion__item--open')
        );
        var closeData = toClose.map(function (openItem) {
            var body = openItem.querySelector('.accordion__body');
            return { item: openItem, body: body, height: body.scrollHeight };
        });

        var openHeight = 0;
        if (!isOpen) {
            var openBody = item.querySelector('.accordion__body');
            item.classList.add('accordion__item--open');
            openHeight = openBody.scrollHeight;
            item.classList.remove('accordion__item--open');
        }

        // Now write
        closeData.forEach(function (d) {
            d.body.style.maxHeight = d.height + 'px';
            d.body.style.opacity   = '1';
            d.item.classList.remove('accordion__item--open');
            d.item.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    d.body.style.maxHeight = '0';
                    d.body.style.opacity   = '0';
                });
            });
        });

        if (!isOpen) {
            item.classList.add('accordion__item--open');
            trigger.setAttribute('aria-expanded', 'true');
            var body = item.querySelector('.accordion__body');
            body.style.maxHeight = '0';
            body.style.opacity   = '0';
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    body.style.maxHeight = openHeight + 'px';
                    body.style.opacity   = '1';
                });
            });
        }
    });

    // ── Footer link groups — accordion on mobile only ────────
    (function () {
        var cols = document.querySelectorAll('.tp-footer__col--collapsible');
        if (!cols.length) return;

        var mq = window.matchMedia('(max-width: 576px)');

        function reset() {
            cols.forEach(function (col) {
                var links = col.querySelector('.tp-footer__links');
                var btn   = col.querySelector('.tp-footer__toggle');
                col.classList.remove('is-open');
                links.style.maxHeight = '';
                if (btn) btn.setAttribute('aria-expanded', mq.matches ? 'false' : 'true');
            });
        }

        document.addEventListener('click', function (e) {
            var btn = e.target.closest('.tp-footer__col--collapsible .tp-footer__toggle');
            if (!btn || !mq.matches) return;

            var col   = btn.closest('.tp-footer__col--collapsible');
            var links = col.querySelector('.tp-footer__links');
            var open  = col.classList.toggle('is-open');

            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            // is-open is already applied, so scrollHeight includes the open padding.
            links.style.maxHeight = open ? links.scrollHeight + 'px' : '0';
        });

        if (mq.addEventListener) {
            mq.addEventListener('change', reset);
        } else if (mq.addListener) {
            mq.addListener(reset);
        }
        reset();
    })();

    // ── Hero badge — tap/click reveals the text and plays the song ────────────
    (function () {
        var badge = document.querySelector('.tp-hero__badge');
        if (!badge) return;

        var VIDEO_ID = 'LYfHmrvEINQ';
        var player   = null;   // YT.Player instance, built on first click
        var playing  = false;

        // Lazily inject the YouTube IFrame API — only after the first click so
        // the hero stays free of render-blocking requests (PageSpeed).
        function loadApi(cb) {
            if (window.YT && window.YT.Player) { cb(); return; }
            var prev = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
                if (typeof prev === 'function') prev();
                cb();
            };
            if (!document.getElementById('tp-yt-api')) {
                var s = document.createElement('script');
                s.id  = 'tp-yt-api';
                s.src = 'https://www.youtube.com/iframe_api';
                document.head.appendChild(s);
            }
        }

        // Off-screen host — YT.Player swaps this <div> for a 1px iframe we only
        // ever use for audio.
        function buildPlayer(onReady) {
            var host = document.createElement('div');
            host.id = 'tp-hero-player';
            host.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;pointer-events:none;';
            document.body.appendChild(host);
            player = new YT.Player(host, {
                videoId: VIDEO_ID,
                playerVars: { playsinline: 1 },
                events: {
                    onReady: onReady,
                    onStateChange: function (e) {
                        playing = (e.data === YT.PlayerState.PLAYING);
                        badge.classList.toggle('is-playing', playing);
                    }
                }
            });
        }

        badge.addEventListener('click', function () {
            var open = badge.classList.toggle('is-open');
            badge.setAttribute('aria-expanded', open ? 'true' : 'false');

            // Player already exists — just toggle play/pause.
            if (player) {
                if (playing) { player.pauseVideo(); } else { player.playVideo(); }
                return;
            }
            // First click (a user gesture) — spin up the API, then play with sound.
            loadApi(function () {
                buildPlayer(function () {
                    player.unMute();
                    player.playVideo();
                });
            });
        });
    })();

    // ── Programs tabs (desktop) ──────────────────────────────
    document.querySelectorAll('.tp-progtabs').forEach(function (root) {
        var tabs   = root.querySelectorAll('.tp-progtabs__tab');
        var panels = root.querySelectorAll('.tp-progtabs__panel');

        root.addEventListener('click', function (e) {
            var btn = e.target.closest('.tp-progtabs__tab');
            if (!btn) return;
            var idx = btn.getAttribute('data-progtab');

            tabs.forEach(function (t) {
                var on = t === btn;
                t.classList.toggle('is-active', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            panels.forEach(function (p) {
                p.classList.toggle('is-active', p.getAttribute('data-progpanel') === idx);
            });
        });
    });

    // ── Programs cards — accordion on mobile only ────────────
    (function () {
        var cards = document.querySelectorAll('.tp-cards--260 .tp-card--hover, .tp-cards--300 .tp-card--hover');
        if (!cards.length) return;

        var mq = window.matchMedia('(max-width: 600px)');

        function reset() {
            cards.forEach(function (card) {
                card.classList.remove('is-open');
                var text = card.querySelector('.tp-card__text');
                if (text) text.style.maxHeight = '';
            });
        }

        document.addEventListener('click', function (e) {
            if (!mq.matches) return;
            var card = e.target.closest('.tp-cards--260 .tp-card--hover, .tp-cards--300 .tp-card--hover');
            if (!card) return;

            // "View program" link keeps the anchor's default navigation.
            if (e.target.closest('.tp-card__go')) return;

            e.preventDefault(); // on mobile the card toggles instead of navigating
            var text = card.querySelector('.tp-card__text');
            var willOpen = !card.classList.contains('is-open');

            // Single-open: opening one card closes the others in the same list.
            if (willOpen) {
                var list = card.closest('.tp-cards');
                if (list) {
                    list.querySelectorAll('.tp-card--hover.is-open').forEach(function (other) {
                        if (other === card) return;
                        other.classList.remove('is-open');
                        var ot = other.querySelector('.tp-card__text');
                        if (ot) ot.style.maxHeight = '';
                    });
                }
            }

            card.classList.toggle('is-open', willOpen);
            if (text) {
                // is-open already applied, so scrollHeight includes the open margin.
                text.style.maxHeight = willOpen ? text.scrollHeight + 'px' : '';
            }
        });

        if (mq.addEventListener) {
            mq.addEventListener('change', reset);
        } else if (mq.addListener) {
            mq.addListener(reset);
        }
        reset();
    })();

    // ── Trainers slider ──────────────────────────────────────
    document.querySelectorAll('.trainers-swiper').forEach(function (el) {
        var wrap = el.closest('.trainers__slider-wrap');
        new Swiper(el, {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: wrap.querySelector('.trainers__nav--next'),
                prevEl: wrap.querySelector('.trainers__nav--prev'),
            },
            breakpoints: {
                0:    { slidesPerView: 1, spaceBetween: 16, centeredSlides: false },
                600:  { slidesPerView: 2, spaceBetween: 20, centeredSlides: false },
                1024: { slidesPerView: 3, spaceBetween: 24, centeredSlides: true },
            },
        });
    });

    // ── Home trainers slider ─────────────────────────────────
    document.querySelectorAll('.home-trainers__swiper').forEach(function (el) {
        var root = el.closest('.home-trainers__carousel');
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: root.querySelector('.home-trainers__nav--next'),
                prevEl: root.querySelector('.home-trainers__nav--prev'),
            },
            pagination: {
                el: root.querySelector('.home-trainers__dots'),
                clickable: true,
            },
        });
    });

    // ── Home reviews slider ──────────────────────────────────
    document.querySelectorAll('.home-reviews__swiper').forEach(function (el) {
        var frame = el.closest('.home-reviews__frame');
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 18,
            navigation: {
                nextEl: frame.querySelector('.home-reviews__nav--next'),
                prevEl: frame.querySelector('.home-reviews__nav--prev'),
            },
            pagination: {
                el: frame.querySelector('.home-reviews__dots'),
                clickable: true,
            },
            breakpoints: {
                576:  { slidesPerView: 2, spaceBetween: 18 },
                834:  { slidesPerView: 3, spaceBetween: 18 },
                1024: { slidesPerView: 4, spaceBetween: 18 },
            },
        });
    });

    // ── Default landing reviews slider ───────────────────────
    document.querySelectorAll('.tp-reviews-slider__swiper').forEach(function (el) {
        var wrap = el.closest('.tp-reviews-slider');
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 16,
            navigation: {
                nextEl: wrap.querySelector('.tp-reviews-slider__nav--next'),
                prevEl: wrap.querySelector('.tp-reviews-slider__nav--prev'),
            },
            pagination: {
                el: wrap.querySelector('.tp-reviews-slider__dots'),
                clickable: true,
            },
            breakpoints: {
                576: { slidesPerView: 2, spaceBetween: 16 },
                834: { slidesPerView: 3, spaceBetween: 16 },
            },
        });
    });

    // ── Reviews page: category card grids → slider on mobile only ──
    // Desktop keeps the CSS grid; on mobile each category with more than one
    // review turns into a one-per-view Swiper (same look as the other sliders).
    (function () {
        var sliders = Array.prototype.slice.call(document.querySelectorAll('.rv-theme__slider'));
        if (!sliders.length || typeof Swiper === 'undefined') return;
        var mq = window.matchMedia('(max-width: 767px)');
        var instances = [];
        function sync() {
            sliders.forEach(function (el, i) {
                var slides = el.querySelectorAll('.swiper-slide').length;
                if (mq.matches && slides > 1 && !instances[i]) {
                    instances[i] = new Swiper(el, {
                        slidesPerView: 1,
                        spaceBetween: 16,
                        pagination: { el: el.querySelector('.rv-theme__dots'), clickable: true },
                    });
                } else if (instances[i] && (!mq.matches || slides <= 1)) {
                    instances[i].destroy(true, true);
                    instances[i] = null;
                }
            });
        }
        sync();
        mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    })();

    // ── Testimonials slider ──────────────────────────────────
    document.querySelectorAll('.testimonials-swiper').forEach(function (el) {
        var right = el.closest('.testimonials__right');
        var pag   = right ? right.querySelector('.testimonials__pagination') : null;
        new Swiper(el, {
            slidesPerView: 3,
            spaceBetween: 20,
            loop: true,
            watchOverflow: false,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            preventClicks: false,
            preventClicksPropagation: false,
            autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
            pagination: { el: pag, clickable: true },
            breakpoints: {
                0:    { slidesPerView: 1, spaceBetween: 16 },
                600:  { slidesPerView: 2, spaceBetween: 16 },
                1336: { slidesPerView: 3, spaceBetween: 20 },
            },
            on: {
                init: function () { if (pag) pag.style.display = 'flex'; },
                breakpoint: function () { if (pag) pag.style.display = 'flex'; },
            },
        });

        // Allow clicks on author links without triggering slide change
        el.querySelectorAll('.testimonials__card-author a').forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.stopPropagation();
            });
        });
    });

    // ── Banner parallax ──────────────────────────────────────
    window.addEventListener('load', function () {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
        gsap.registerPlugin(ScrollTrigger);
        var isMobile = window.innerWidth < 1024;
        var yStart = isMobile ? -12 : -25;
        var yEnd   = isMobile ?  12 :  25;
        document.querySelectorAll('.acf-block-banner').forEach(function (section) {
            var bg = section.querySelector('.banner__bg');
            if (!bg) return;
            gsap.fromTo(bg,
                { yPercent: yStart },
                { yPercent: yEnd, ease: 'none', scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: true, invalidateOnRefresh: true } }
            );
        });
    });

    // ── Goal pill buttons ────────────────────────────────────
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.goal-btn');
        if (!btn) return;
        btn.classList.toggle('goal-btn--active');
        var active = Array.from(btn.closest('.form-block__goals-list').querySelectorAll('.goal-btn--active'))
            .map(function (b) { return b.dataset.value; });
        var goalField = document.getElementById('cf_goal');
        if (goalField) goalField.value = active.join(', ');
    });

    // ── Scroll to form ───────────────────────────────────────
    var formSections = document.querySelectorAll('.acf-block-form');
    var lastForm = formSections[formSections.length - 1] || null;
    document.querySelectorAll('.js-to-form').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            if (!lastForm) return;
            e.preventDefault();
            var top = lastForm.getBoundingClientRect().top + window.pageYOffset - 100;
            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    });

    // ── Price page ───────────────────────────────────────────
    if (document.querySelector('.page-price')) {
        function toEmbedUrl(url) {
            var u = url.trim();
            if (/youtu\.be\//.test(u)) {
                u = u.replace(/.*youtu\.be\/([^?]+).*/, 'https://www.youtube.com/embed/$1');
            } else if (/youtube\.com\/watch/.test(u)) {
                var id = u.match(/[?&]v=([^&]+)/);
                u = id ? 'https://www.youtube.com/embed/' + id[1] : u;
            } else if (/vimeo\.com\/(\d+)/.test(u)) {
                var vid = u.match(/vimeo\.com\/(\d+)/);
                u = vid ? 'https://player.vimeo.com/video/' + vid[1] : u;
            }
            return u + (u.includes('?') ? '&' : '?') + 'autoplay=1&rel=0';
        }

        document.querySelectorAll('.js-price-play').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var screen = btn.closest('.js-price-screen');
                var iframe = screen ? screen.querySelector('.js-price-iframe') : null;
                if (!iframe) return;
                iframe.src = toEmbedUrl(btn.dataset.video);
                screen.classList.add('is-playing');
            });
        });
    }

    // ── Contact forms AJAX ───────────────────────────────────
    function formatPhone(val) {
        var digits = val.replace(/\D/g, '');
        if (digits.length > 0 && digits[0] === '1') digits = digits.slice(1);
        digits = digits.slice(0, 10);
        if (!digits) return '';
        var r = '+1 (' + digits.slice(0, 3);
        if (digits.length > 3) r += ') ' + digits.slice(3, 6);
        if (digits.length > 6) r += '-' + digits.slice(6, 10);
        return r;
    }

    document.querySelectorAll('.js-contact-form').forEach(function (form) {
        var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        var phoneRe = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

        form.querySelectorAll('[type=email]').forEach(function (el) {
            el.addEventListener('input', function () {
                el.classList.remove('input--error');
                var msg = form.querySelector('.js-form-msg');
                if (msg) { msg.className = 'form-block__msg js-form-msg'; msg.textContent = ''; }
            });
        });

        form.querySelectorAll('[type=tel]').forEach(function (el) {
            el.addEventListener('input', function () {
                var pos = el.selectionStart;
                var oldLen = el.value.length;
                el.value = formatPhone(el.value);
                var newLen = el.value.length;
                el.setSelectionRange(pos + (newLen - oldLen), pos + (newLen - oldLen));
                el.classList.remove('input--error');
                var msg = form.querySelector('.js-form-msg');
                if (msg) { msg.className = 'form-block__msg js-form-msg'; msg.textContent = ''; }
            });
        });

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            var btn        = form.querySelector('.form-block__submit');
            var msg        = form.querySelector('.js-form-msg');
            var emailInput = form.querySelector('[type=email]');
            var phoneInput = form.querySelector('[type=tel]');
            var valid      = true;

            [emailInput, phoneInput].forEach(function (el) { if (el) el.classList.remove('input--error'); });
            if (msg) { msg.className = 'form-block__msg js-form-msg'; msg.textContent = ''; }

            if (emailInput && !emailRe.test(emailInput.value.trim())) {
                emailInput.classList.add('input--error'); valid = false;
            }
            if (phoneInput && phoneInput.value.trim() && !phoneRe.test(phoneInput.value.trim())) {
                phoneInput.classList.add('input--error'); valid = false;
            }
            if (!valid) {
                if (msg) { msg.classList.add('error'); msg.textContent = 'Please enter a valid email and phone number.'; }
                return;
            }

            var params = new URLSearchParams(new FormData(form));
            params.set('action', 'contact_form_submit');
            params.set('contact_nonce', (window.appVars && window.appVars.nonce) || '');
            params.set('page_url', window.location.href);

            btn.disabled    = true;
            btn.textContent = 'Sending...';

            fetch((window.appVars && window.appVars.ajaxurl) || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            })
            .then(function (r) { return r.json(); })
            .then(function (res) {
                if (!msg) return;
                if (res.success) {
                    window.location.href = '/thank-you/';
                } else {
                    msg.classList.add('error');
                    msg.textContent = res.data.message;
                }
            })
            .catch(function () {
                if (msg) { msg.classList.add('error'); msg.textContent = 'Something went wrong. Please try again.'; }
            })
            .finally(function () {
                btn.disabled    = false;
                btn.textContent = btn.dataset.label || 'SUBMIT';
            });
        });
    });

});
